import { render, staticRenderFns } from "./MenuTree.vue?vue&type=template&id=33b1b63b&scoped=true&"
import script from "./MenuTree.vue?vue&type=script&lang=js&"
export * from "./MenuTree.vue?vue&type=script&lang=js&"
import style0 from "./MenuTree.vue?vue&type=style&index=0&id=33b1b63b&prod&lang=scss&scoped=true&"
import style1 from "./MenuTree.vue?vue&type=style&index=1&id=33b1b63b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b1b63b",
  null
  
)

export default component.exports